import { PolicyTypes } from "@enums/policy-types";
import { SelectOption } from "@idw-types/common";

export const POLICY_TYPE_DEFAULT_OPTION = { label: "None", value: PolicyTypes.NONE };

export const POLICY_TYPE_OPTIONS: Array<SelectOption> = [
    { label: "Decision Engine", value: PolicyTypes.DECISION_ENGINE },
    { label: "Trust Score", value: PolicyTypes.TRUST_SCORE },
    { label: "Always Obligate", value: PolicyTypes.ALWAYS_OBLIGATE },
    { label: "Always Approve", value: PolicyTypes.ALWAYS_APPROVE },
    { label: "Always Deny", value: PolicyTypes.ALWAYS_DENY },
    POLICY_TYPE_DEFAULT_OPTION,
];
